import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'safeUrl', standalone: true })
export class SafeUrlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    value = value.trim();
    if (value.startsWith('http://') || value.startsWith('https://')) {
      return value;
    }
    return 'https://' + value;
  }
}
